import { render, staticRenderFns } from "./promoteLogin.vue?vue&type=template&id=621004fe&scoped=true&"
import script from "./promoteLogin.vue?vue&type=script&lang=js&"
export * from "./promoteLogin.vue?vue&type=script&lang=js&"
import style0 from "./promoteLogin.vue?vue&type=style&index=0&id=621004fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621004fe",
  null
  
)

export default component.exports